import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employ',
  templateUrl: './employ.component.html',
  styleUrls: ['./employ.component.scss', './employ.component.media.scss']
})
export class EmployComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
